var _a;
import { FULL_ACCESS_ACTION_NAMES } from '@wix/wix-vod-shared/dist/src/widget/ui-selectors/video-access';
export default (_a = {},
    _a[FULL_ACCESS_ACTION_NAMES.BUY] = 'widget.overlay-buttons.buy',
    _a[FULL_ACCESS_ACTION_NAMES.RENT] = 'widget.overlay-buttons.rent',
    _a[FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT] = 'widget.overlay-buttons.buy-from-small',
    _a[FULL_ACCESS_ACTION_NAMES.SUBSCRIBE] = 'widget.overlay-buttons.get-subscription-small',
    _a);
